var _circle, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporateMoonDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.08 14.202c.195 1.222-.127 1.491-.622 2.628-.495 1.138-.183 2.068-1.214 2.766a6.6 6.6 0 0 1-3.482 1.132 6.569 6.569 0 0 1-3.544-.9 6.501 6.501 0 0 1-2.5-2.65 6.473 6.473 0 0 1-.677-3.575A6.516 6.516 0 0 1 10.4 10.22a6.582 6.582 0 0 1 2.97-2.137 5.042 5.042 0 0 0 2.117 6.264c1.05.617 1.89 1.491 3.092 1.276 1.202-.215 1.73-.477 2.502-1.42z",
    fill: "#C9A87A",
    fillOpacity: 0.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 14.63A7.015 7.015 0 1 1 13.37 7 5.456 5.456 0 0 0 21 14.63z",
    stroke: "url(#ug6v0lzwka)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ug6v0lzwka",
    x1: 17.119,
    y1: 12.143,
    x2: 9.431,
    y2: 12.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9A87A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343E47"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateMoonDark);
export default __webpack_public_path__ + "static/media/corporateMoonDark.5a60142ece6635969a156384eb833072.svg";
export { ForwardRef as ReactComponent };